export const IMAGE_SIZE = 10;
export const IMAGE_MIN_RESOLUTION = 200;
export const IMAGE_MAX_RESOLUTION = 4000;
